module.exports = new __parcel__URL__("apply_c_faq_closed_btn_zh-cn.3914e2dd.webp").toString();